/**
 * @typedef {'all' | 'exported_only' | 'new_only'} OfflineExportScope
 */

/**
 * Filtra righe localIncidents per export ZIP in base alla scelta utente.
 * - all: tutti gli incidenti offline esportabili (esclusi draft_local)
 * - exported_only: solo già marcati exported (legacy / test)
 * - new_only: non ancora inclusi in un export ZIP (queued, synced)
 *
 * @param {Array<{ status: string }>} rows
 * @param {OfflineExportScope} scope
 * @returns {typeof rows}
 */
export function filterLocalIncidentsForExport(rows, scope) {
  if (scope === 'exported_only') {
    return rows.filter((r) => r.status === 'exported')
  }
  if (scope === 'new_only') {
    return rows.filter(
      (r) => r.status !== 'draft_local' && r.status !== 'exported'
    )
  }
  return rows.filter((r) => r.status !== 'draft_local')
}

/**
 * Conta incidenti offline salvati ma non ancora inclusi in un export ZIP.
 *
 * @param {Array<{ status: string }>} rows
 * @returns {number}
 */
export function countUnexportedLocalIncidents(rows) {
  return filterLocalIncidentsForExport(rows, 'new_only').length
}
